export default __webpack_public_path__ + "static/media/list-icon.fff22444.svg";